import React from 'react';
import { useRouter } from 'next/router';
import NextLink from 'next/link';
import { Typography, Button } from '@mui/material';
import { useStyles } from './styles';
import { setLocale } from 'utils/locale';

import en from './locales/en';
import ja from './locales/en';
import zh from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';

export default function FriendsReferralBanner() {
  const classes = useStyles();
  const router = useRouter();
  const { locale } = router;
  const t = setLocale(locale, { en, es, fr, it, ja, zh });

  return (
    <div className={classes.root}>
      <img src="/images/gift-icon-white.svg" alt="Gift icon" />

      <Typography className={classes.invite}>{t.title}</Typography>

      <NextLink passHref={true} href="/friends-referral">
        <Button className={classes.button} color="primary" variant="contained">
          {t.textButton}
        </Button>
      </NextLink>
    </div>
  );
}
